import { v4 as uuidv4 } from "uuid";
export class AssetLookupSearchModel {
    constructor() {
        this.id = uuidv4();
        this.name = "";
        this.assetCode = "";
    }
}
export default class AssetAssignment extends AssetLookupSearchModel {
    constructor(model) {
        super();
        Object.assign(this, model);
    }
}
